import { Component } from '@angular/core';
import { CommonService } from '../../shared/common/common.service';
import { CommonStandaloneImports } from '../../shared/common/common-standalone-imports';

@Component({
  standalone: true,
  selector: 'app-privacy-policy',
  imports: [CommonStandaloneImports],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss'
})
export class PrivacyPolicyComponent {
   constructor(
      public commonService:CommonService
    ) {}
    show: boolean = false;
    ngOnInit(): void {
      setTimeout(() => {
      this.show = true;
    }, 0);
  }
}
